import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import CategoryForm from "./CategoryForm";
import { getErrorMessage } from "../../utils/errorHandler";
import { updateCategory, getCategoryById } from "../../api/categoryService";

export default function EditCategory() {
  const navigate = useNavigate();
  const location = useLocation();

  const categoryId = location?.state?.categoryId;
  const slug = location?.state?.slug;
  const [backendErrors, setBackendErrors] = useState({});
  const [categoryData, setCategoryData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);

  // =========================
  // LOAD CATEGORY
  // =========================
  const loadCategory = async () => {
    try {
      setPageLoading(true);
      const res = await getCategoryById(slug);
      setCategoryData(res?.data || res);
    } catch (error) {
      console.log("Fetch Category Error:", error);
      alert(getErrorMessage(error));
    } finally {
      setPageLoading(false);
    }
  };

  useEffect(() => {
    if (!categoryId) {
      console.log("Category ID not found");
      navigate("/categories");
      return;
    }

    loadCategory();
  }, [categoryId, navigate]);

  // =========================
  // UPDATE CATEGORY
  // =========================
  const handleUpdate = async (formData) => {
    try {
      const response = await updateCategory(categoryId, formData);

      if (response?.success === false || response?.status === 422) {
        setBackendErrors(response?.error || {});
        return;
      }
      return response;
    } catch (error) {
      console.log("Update Error:", error);
      alert(getErrorMessage(error));
    } finally {
      setPageLoading(false);
    }
  };

  if (pageLoading) {
    return <div className="text-center mt-4">Loading category details...</div>;
  }

  return (
    <div>
      <CategoryForm
        isEdit={true}
        loading={loading}
        onSubmit={handleUpdate}
        backendErrors={backendErrors}
        initialData={{
          name: categoryData?.name || "",
          tagline: categoryData?.tagline || "",
          description: categoryData?.description || "",
          hsnCode: categoryData?.hsnCode || "",
          taxApplied: categoryData?.taxApplied ?? false,
          taxId: categoryData?._id || "",
          metaTitle: categoryData?.metaTitle || "",
          metaKeywords: Array.isArray(categoryData?.metaKeywords)
            ? categoryData.metaKeywords.join(", ")
            : categoryData?.metaKeywords || "",
          metaDescription: categoryData?.metaDescription || "",
        }}
      />
    </div>
  );
}
